import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=e3ca9b42&scoped=true&"
import script from "./TeamMember.vue?vue&type=script&lang=ts&"
export * from "./TeamMember.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMember.vue?vue&type=style&index=0&id=e3ca9b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ca9b42",
  null
  
)

export default component.exports